export const defaultData = {
  showPrice: false,
  showBaseScenario: true,
  showDescription: true,
}

export { default as EditDataForm } from "./EditDataForm"
export { default as FragComponent } from "./FragComponent"
export { default as pageSplitter } from "./pageSplitter"
